import axios from "axios";
import config from "./config";

export const softwareTokenMfa = (body) => {
  return axios.post("/challenges/software-token-mfa-code", body, config);
}